import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'vi_VN',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '145e4280-0f22-4db5-8246-d11921769e06',
  ''
);
